import React from 'react';
import { graphql, StaticQuery } from 'gatsby';
import { Row, Col } from 'react-flexbox-grid';
import {
  Section,
  SectionHeader,
  BoxProfile,
  Paragraph,
  IconSVG,
  Heading,
} from 'components';
import './BusinessConsultants.scss';

const BusinessConsultants = () => (
  <StaticQuery
    query={graphql`
      query {
        ulaRzadImage: file(relativePath: { eq: "people/ula-rzad.png" }) {
          childImageSharp {
            fluid(maxWidth: 500) {
              ...GatsbyImageSharpFluid_withWebp
            }
          }
        }
        kasiaOrubaImage: file(
          relativePath: { eq: "people/katarzyna-oruba.jpg" }
        ) {
          childImageSharp {
            fluid(maxWidth: 500) {
              ...GatsbyImageSharpFluid_withWebp
            }
          }
        }
        pawelKaiserImage: file(
          relativePath: { eq: "people/pawel-kaiser.jpg" }
        ) {
          childImageSharp {
            fluid(maxWidth: 500) {
              ...GatsbyImageSharpFluid_withWebp
            }
          }
        }
        adamZiembaImage: file(
          relativePath: { eq: "people/adam-ziemba.jpeg" }
        ) {
          childImageSharp {
            fluid(maxWidth: 500) {
              ...GatsbyImageSharpFluid_withWebp
            }
          }
        }
      }
    `}
    render={data => (
      <Section additionalClass={'connect-page__consultants'}>
        <SectionHeader
          size={'big'}
          lineColor={'violet'}
          fixed
          additionalClass={'section-header__description--medium'}
        >
          Contact our Customer Success Guides
        </SectionHeader>
        <Row className={'no-gap'}>
          <Col sm={12} md={6}>
            <Paragraph
              size={'medium'}
              additionalClass={
                'connect-page__consultants-description text--default'
              }
            >
              Customer Success Guides help our clients from the early stages of
              product discovery, through responding to product needs and
              supporting ongoing innovation all the way to fulfilling
              high-level business goals.
              <br />
              <br />
              Connect with them to see how we can support your product or a
              successful digital transformation process.
            </Paragraph>
          </Col>
          <Col sm={12} md={6}>
            <Row className={'no-gap connect-page__profile-list'}>
              <Col sm={6} className={'connect-page__profile'}>
                <BoxProfile
                  photo={data.ulaRzadImage.childImageSharp.fluid}
                  name={'Urszula Rząd'}
                  job={'Customer Success Guide'}
                  twitter={'https://twitter.com/orszulkaja'}
                  linkedin={'https://www.linkedin.com/in/urszularzad/'}
                  additionalClass={'connect-page__profile--left'}
                />
              </Col>
              <Col sm={6} className={'connect-page__profile'}>
                <BoxProfile
                  photo={data.pawelKaiserImage.childImageSharp.fluid}
                  name={'Paweł Kaiser'}
                  job={'Customer Success Guide'}
                  linkedin={
                    'https://www.linkedin.com/in/paweł-kaiser-74445364'
                  }
                  additionalClass={'connect-page__profile--right'}
                />
              </Col>
            </Row>
          </Col>
          <Col sm={12} md={6}>
            <Row className={'no-gap connect-page__profile-list'}>
              <Col sm={6} className={'connect-page__profile'}>
                <BoxProfile
                  photo={data.adamZiembaImage.childImageSharp.fluid}
                  name={'Adam Ziemba'}
                  job={'Customer Success Guide'}
                  quora={'https://www.quora.com/profile/Adam-Ziemba-1'}
                  linkedin={'https://www.linkedin.com/in/adam-ziemba/ '}
                  additionalClass={'connect-page__profile--left'}
                />
              </Col>
              <Col sm={6} className={'connect-page__profile'}>
                <BoxProfile
                  photo={data.kasiaOrubaImage.childImageSharp.fluid}
                  name={'Katarzyna Oruba'}
                  job={'Customer Success Guide'}
                  linkedin={
                    'https://www.linkedin.com/in/katarzyna-oruba-2638b251/'
                  }
                  additionalClass={'connect-page__profile--right'}
                />
              </Col>
            </Row>
          </Col>
          <Col sm={12} md={6}>
            <div className={'connect-page__consultants-testimonial'}>
              <IconSVG name={'quote'} size={'medium'} color={'black'} />
              <Heading color={'red'} size={'medium-plus'} type={3}>
                The Customer Success Guide at Boldare performed some magic over
                the last year to support sonnen with very talented and
                motivated teams in a surprisingly short time.
              </Heading>
              <Paragraph
                color={'black'}
                size={'small'}
                additionalClass={'text--light'}
              >
                Michael Konder, Product Owner, sonnen
              </Paragraph>
            </div>
          </Col>
        </Row>
      </Section>
    )}
  />
);

export default BusinessConsultants;
